import Vue from 'vue'
import Vuex from 'vuex'
import AuthStore from './auth'
import NotificationStore from './notifications'
Vue.use(Vuex)

export default new Vuex.Store({
  ...AuthStore,
  modules: {
    notification: NotificationStore
  }
})
